import { render, staticRenderFns } from "./BrothersByChick.vue?vue&type=template&id=3b3ff202&scoped=true"
import script from "./BrothersByChick.vue?vue&type=script&lang=js"
export * from "./BrothersByChick.vue?vue&type=script&lang=js"
import style0 from "./BrothersByChick.vue?vue&type=style&index=0&id=3b3ff202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3ff202",
  null
  
)

export default component.exports